import React from 'react';
import {Button, Col, Modal, ProgressBar, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleCheck, faCircleExclamation, faCircleInfo, faClock} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { formatBeijingTime } from "../api/TimeService";

const CopyInfoModal = ({visible, copyInfo, onClose}) => {

    const [isMobile, setIsMobile] = React.useState(false);
    React.useEffect(() => {
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };

        handleResize(); // 初始化时调用
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <Modal show={visible} centered onHide={onClose}
               style={{'--bs-modal-margin': '2rem', '--bs-modal-width': '700px'}}>
            <Modal.Header closeButton style={{
                background: 'linear-gradient(90deg,#02C8E3 30%, #963BC8 120%)',
                borderBottomColor: 'transparent'
            }}>
                <div className={isMobile ? 'd-flex flex-column' : 'd-flex flex-row'}>
                    <span style={{color: '#060606', fontSize: '22px'}}>{copyInfo?.agent.title}</span>
                    <span style={{
                        backgroundColor: copyInfo?.status === 2 ? '#02C8E3' : (copyInfo?.status === -1 ? '#DE4444' : '#f4f238'),
                        borderRadius: '50px',
                        fontSize: '12px',
                        padding: '2px 10px',
                        alignSelf: 'end',
                        margin: isMobile ? '0' : '0 10px'
                    }}>
                                            {copyInfo?.status === 2 && <FontAwesomeIcon icon={faCircleCheck} size={'1x'}
                                                                                        style={{marginRight: '4px'}}/>}
                        {copyInfo?.status != -1 && copyInfo?.status != 2 &&
                            <FontAwesomeIcon icon={faClock} size={'1x'}
                                             style={{marginRight: '4px'}}/>}
                        {copyInfo?.status === -1 &&
                            <FontAwesomeIcon icon={faCircleExclamation} size={'1x'}
                                             style={{marginRight: '4px'}}/>}
                        {copyInfo?.status === 2 ? '人工迁移成功' : (copyInfo?.status === -1 ? '失败' : '复制中')}</span> {/* 添加 状态 标签 */}
                </div>
            </Modal.Header>
            <Modal.Body style={{background: '#1E2129'}}>
                <div style={{ padding: '16px',}}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: '18px',
                        color:'#B4BFC5',
                    }}> 
                        <span><FontAwesomeIcon icon={faCircleExclamation} color={'#02C8E3'} style={{marginRight: '4px'}} size={'1x'}/>任务信息</span>
                    </div>
                    <div style={{
                        // display: 'flex',
                        // justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '10px',
                        background:'#141720',
                        padding: '10px',
                        fontSize: '14px'
                    }}>
                        <div className={'mb-2'} style={{color: '#B4BFC5', fontSize: '16px'}}>{copyInfo?.agent.title}</div>
                        <Row>
                            <Col xs={12} md={6}>
                                <div className={'mb-2'} style={{color: '#B4BFC5', }}><span style={{color: '#02C8E3', }}>来源空间：</span>沸推AI</div>
                            </Col>
                            <Col xs={12} md={6}>
                                <div className={'mb-2'} style={{color: '#B4BFC5', }}><span style={{color: '#02C8E3', }}>目标空间：</span>{copyInfo?.cozeSpaceId}</div>
                            </Col>
                            <Col xs={12} md={6}>
                                <div className={'mb-2'} style={{color: '#B4BFC5', }}><span style={{color: '#02C8E3', }}>创建时间：</span>{formatBeijingTime(copyInfo?.created)}</div>
                            </Col>
                            <Col xs={12} md={6}>
                                <div className={'mb-2'} style={{color: '#B4BFC5', }}><span style={{color: '#02C8E3', }}>完成时间：</span>{formatBeijingTime(copyInfo?.created)}</div>
                            </Col>

                        </Row>
                    </div>
                    <div style={{
                        width: '100%',
                        marginTop: '10px',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}>
                        <span style={{color: '#B4BFC5', fontSize: '12px', flexShrink: '0'}}>迁移进度：</span>
                        <ProgressBar completed={copyInfo?.status === 2 ? 100 : 0} now={copyInfo?.status === 2 ? 100 : 0}
                                     style={{
                                         width: '100%',
                                         height: '6px',
                                         '--bs-progress-bar-bg': '#02C8E3',
                                         marginLeft: '10px',
                                         marginRight: '10px'
                                     }}/>
                        <span style={{
                            color: '#B4BFC5',
                            fontSize: '12px',
                            display: 'flex',
                            justifySelf: 'end',
                            flexShrink: '0'
                        }}>进度：{copyInfo?.status === 2 ? '100%' : '0%'}</span>
                    </div>
                    {copyInfo?.status === 2 && (
                        <div style={{
                            backgroundColor: 'rgba(2,200,227,0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '14px',
                            color:'#02C8E3',
                            padding: '10px',
                            marginTop: '10px',
                        }}>
                            <span><FontAwesomeIcon icon={faCircleExclamation} color={'#02C8E3'} style={{marginRight: '4px'}} size={'1x'}/>完成信息：移动空间成功</span>
                        </div>
                    )}
                    {
                        copyInfo?.status === -1 && (
                            <div style={{
                                backgroundColor: 'rgba(255,0,0,0.2)',
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '14px',
                                color:'#BC2B2B',
                                padding: '10px',
                                marginTop: '10px',
                            }}>
                                <span><FontAwesomeIcon icon={faCircleExclamation} color={'#BC2B2B'} style={{marginRight: '4px'}} size={'1x'}/>失败原因：{copyInfo?.reason}</span>
                            </div>
                        )
                    }


                </div>
            </Modal.Body>
            <Modal.Footer style={{background: '#1E2129', borderTopColor: '#707070'}}>
                <Button variant="primary" onClick={onClose} style={{
                    background: 'linear-gradient(90deg,#02C8E3,#963BC8)',
                    border: 'none',
                    padding: '12px 40px',
                    color: '#060606'
                }}>
                    前往查看智能体
                </Button>
                <Button variant="primary" onClick={onClose} style={{
                    background: '#393D47',
                    border: 'none',
                    padding: '12px 40px',
                    color: '#B4BFC5'
                }}>
                    关闭
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CopyInfoModal;